import { render, staticRenderFns } from "./agentTransferDetail.vue?vue&type=template&id=2a977d51"
import script from "./agentTransferDetail.vue?vue&type=script&lang=js"
export * from "./agentTransferDetail.vue?vue&type=script&lang=js"
import style0 from "./agentTransferDetail.vue?vue&type=style&index=0&id=2a977d51&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports